import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { EntityData } from '@new/common/utils/entity-data';
import { RemoteData } from '@new/common/utils/remote-data';
import { TableErrorComponent } from './table-error/table-error.component';

@Component({
  selector: 'man-table-wrapper',
  templateUrl: './table-wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TableErrorComponent, CommonModule]
})
export class TableWrapperComponent {
  @Input() public request: EntityData<unknown> | RemoteData<unknown>;

  public get isFailure(): boolean {
    if ('query' in this.request) {
      return this.request.query.state === 'failure';
    }

    return this.request.requestState === 'failure';
  }
}
